<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HlnX1O/tc-custom/9781783038220.jpg?1699746149010" alt="This image is the cover for the book Armoured Warfare on the Eastern Front, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Armoured Warfare on the Eastern Front, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <b>A pictorial history and analysis of the tank warfare between Red Soviet and Nazi forces along the Eastern Front during World War II.</b><br/><br/> On the Eastern Front during the Second World War, massive Soviet and German tank armies clashed in a series of battles that were unmatched in their scale and ferocity. Several of them have attained almost legendary status. But epic encounters such as these were only part of a broader story, as Anthony Tucker-Jones demonstrates in this selection of graphic photographs. While the images give a fascinating inside view of combat, they also reveal the daily routines of tank warfare 65 years ago. Training, maintenance, transportation, and supply are shown, as are the daily lives of the tank crews and the often appalling conditions in which they worked and fought. The photographs also record in vivid detail the destructive reality of armored warfare, from the initial triumphant advance of the German panzers deep into the Soviet Union to the massive Red Army counter-offensives which drove the German armies back to Berlin.<br/><br/><b>Praise for <i>Armoured Warfare on the Eastern Front</i></b><br/><br/><b>“Each chapter includes a useful introduction and the pictures each come with an accurate and informative caption, describing the item in the picture and placing it in context, comparing it to its opponents at the time or looking at production numbers. This is a high quality piece of work, and a useful photographic guide to the armoured vehicles of the Eastern Front.” —History of War</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Tucker-Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c34f21d